module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/theme-floral-2-2a78a8729c04f23e03aab24613497ed6.webp";